<template>
  <v-container>
    <v-dialog v-model="planNPayOn" fullscreen hide-overlay transition="dialog-bottom-transition" app>
      <PlanAndPayment 
      v-if="selectedLocation && selectedLocation.nasid && selectedLocation.nasid > 0"
      :key="'PlanAndPayment::'+selectedLocation.nasid"
      v-bind:owner="owner"
      v-bind:page="planNPayPage"
      v-bind:plans="defaultPlans"
      v-bind:selectedLocation="selectedLocation"
      v-bind:subscriptionName="selectedLocation.subscription.name"
      v-bind:settingId="settingId" 
      v-bind:fromSettings="false"
      v-on:close="planNPayOn = false"></PlanAndPayment>
    </v-dialog>
    <!--<v-btn @click="showPlans = true">PLANS</v-btn>-->
    <v-dialog v-model="showPlans" fullscreen hide-overlay transition="dialog-bottom-transition" app>
      <Plans v-bind:view="welcome" @close="showPlans = false"></Plans>
    </v-dialog>
    <v-dialog v-model="showTroubleShooting" persistent max-width="90%">
      <Troubleshoot v-on:cancel="showTroubleShooting = false"></Troubleshoot>
    </v-dialog>
    <LocationSelector v-bind:storeData="storeData" v-bind:selectedLocation="selectedLocation"
      @select-location="setLocation($event)"></LocationSelector>
    <v-skeleton-loader v-if="!selectedLocation || !selectedLocation.nasid || selectedLocation.nasid == 0" type="list-item-two-line, image, image" ></v-skeleton-loader>
    <div v-if="(selectedSection == 'manage') && selectedLocation && selectedLocation.nasid && selectedLocation.nasid > 0">
      <!-- Usage and Settings -->
      <Settings v-if="manageOrValue == 'manage'" v-bind:storeData="storeData" v-bind:selectedLocation="selectedLocation" v-bind:selectTab="selectTab"
        v-bind:settingId="settingId" :key="'basicSettings::' + selectedLocation.nasid"
        v-on:troubleshoot="showTroubleShooting = true"
        v-on:got-inactive-locations="$emit('got-inactive-locations', $event)"></Settings>
    </div>
    <!-- Value -->
    <div v-if="selectedSection == 'value' && selectedLocation.nasid && selectedLocation.nasid > 0">
      <v-tabs v-model="tab" color="#f26547" background-color="transparent" grow>
        <v-tab
          class="fs-14 fw-400 text-capitalize"
          style="font-weight: 500;font-size: 16px;font-family: inherit;letter-spacing: normal;"
          >Promote</v-tab
        >
        <v-tab
          class="fs-14 fw-400 text-capitalize fs-16"
          style="font-weight: 500;
          font-size: 16px;
          font-family: inherit;
          letter-spacing: normal;"
          >Report</v-tab
        >
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <Promote v-bind:storeData="storeData" v-bind:selectedLocation="selectedLocation" v-bind:settingId="settingId"
            :key="'promote::' + selectedLocation.nasid + '::' + selectedSection" @save-promote="savePromote($event)" />
        </v-tab-item>
        <v-tab-item>
          <Reports v-bind:storeData="storeData" v-bind:selectedLocation="selectedLocation" v-bind:settingId="settingId"
            :key="'reports::' + selectedLocation.nasid" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>



<script>
import LocationSelector from "./../common/LocationSelector";
import Settings from "./../manage/Settings";
import Troubleshoot from "./Troubleshoot";
import Promote from "./../value/Promote";
import Reports from "./../value/Reports";
import axios from "./../../plugins/axios";
import AdminServicesAxios from "./../../plugins/axios-admin-services";
import helper from "./../../utils/helper";
import Plans from "./../common/Plans";
import PlanAndPayment from "./../manage/PlanAndPayment"
import WIOM_APIS from './../../utils/wiom-apis';

export default {
  name: "Dashboard",
  props: ["userId", "selectedSection", "userData", "showNotifications", "selectSection", "selectTab", "selectNasid"],
  components: {
    LocationSelector,
    Settings,
    Troubleshoot,
    Promote,
    Reports,
    Plans,
    PlanAndPayment
  },
  data: function() {
    return {
      welcome: "welcome",
      skipped: false,
      showPlans: false,
      settingId: null,
      selectedLocation: {
        nasid: null,
        storeName: null,
        locality: null,
        subscription : {}
      },
      showAdvanceSetting: false,
      showTroubleShooting: false,
      owner: {
        ownerName: "",
        ownerNumber: "",
        ownerEmailId: ""
      },
      // More Below
      storeData: [],
      manageOrValue: "manage",
      ownerDetailEdit: false,
      locationEditDetails: false,
      tab: null,
      devicesPerUser: 4,
      bottomNav: "manage",
      menudrawer: null,
      planNPayPage: null,
      defaultPlans: null,
      planNPayOn: false
    };
  },
  mounted: function() {
    this.skipped = helper.getCookie("skip-plan") ? true : false;
    this.GetUserLocations();
    this.GetOwnerProfile();
    if(this.selectedLocation && this.selectedLocation.nasid > 0) {

      this.tab = 0;
      if (this.selectTab)
      switch(this.selectTab) {
        case "promote":
          this.tab = 0;
          break;
        case "report":
          this.tab = 1;
          break;
        default:
          this.tab = 0;
          break;
      }
      console.log("TAKING YOU TO : ", this.selectSection,this.selectedLocation.nasid, this.selectTab, this.tab);
    }
  },
  methods: {
    GetUserLocations: async function() {
      let that = this;
      var selectedIndex = 0;
      let userid = this.userData.userid;
      let response = await WIOM_APIS.getLocations(userid);
      that.storeData = response;
      selectedIndex = 0;
      var LOC = helper.getCookie("selectedLocation");
      if (that.selectNasid)
        LOC = parseInt(that.selectNasid);
      console.log("SELECT LOCATION", LOC, that.selectNasid);
      if(LOC) {
        selectedIndex = response.findIndex((loc) => {
          if (loc.nasid == LOC)
            return true;
        })
        if(selectedIndex == -1)
        selectedIndex = 0;
      }

    that.selectedLocation = that.storeData[selectedIndex]
    if(that.selectedLocation) {
      that.selectedLocation.connectionStatus = null;
      that.SearchSettings();
    }      
    
    axios
      .get(
        "/wiom/getdevicestats?nases=" +
          this.selectedLocation.nasid +
          "&days=1"
      )
      .then(response => {
        if (
          response.data.data.connectionStatus[this.selectedLocation.nasid]
            .status == 0
        ) {
          this.selectedLocation.connectionStatus = 0;
        } else {
          this.selectedLocation.connectionStatus = 1;
        }
        this.$emit("location-selected", this.selectedLocation);
      });
    },
    GetOwnerProfile: function() {
      let userid = this.userData.userid;
      axios.get("/wiom/getownerprofile?userid=" + userid).then(response => {
        // console.log(response);
        this.owner.ownerName = response.data.data.name;
        this.owner.ownerNumber = response.data.data.mobile;
        this.owner.ownerEmailId = response.data.data.email;
        this.owner.ownerUsername = response.data.data.username;
        this.owner.profilePhoto = response.data.data.profilePhoto;
        //console.log("got owner profile", this.owner);
        this.$emit("get-owner-details", this.owner);
      });
    },
    setLocation: function(location) {
      this.selectedLocation = location;
      axios
        .get("/wiom/getdevicestats?nases=" + location.nasid + "&days=1")
        .then(response => {
          if (response.data.data.connectionStatus[location.nasid].status == 0) {
            this.selectedLocation.connectionStatus = 0;
          } else {
            this.selectedLocation.connectionStatus = 1;
          }
          this.$emit("location-selected", this.selectedLocation);
        });
      this.SearchSettings();
      
    },
    toggleAdvancedSetting: function(visible) {
      //console.log("toggle advanced setting" + visible);
      this.showAdvanceSetting = visible;
    },
    GetStoreDetails: function() {
      var nasid = this.selectedLocation.nasid;
      axios.get("/wiom/GetStoreDetails?nasid=" + nasid).then(response => {
        // console.log(response);
        this.categeory = response.data.data.data[0].locationSubCategory;
        this.gstNumber = response.data.data.data[0].gst;
        this.locationAddress =
          response.data.data.data[0].address +
          " " +
          response.data.data.data[0].pincode;
        this.packageExpiry = response.data.data.data[0].packageExpiry.slice(
          0,
          10
        );
        this.packageType = response.data.data.data[0].packageType;
        axios
          .get(
            "/wiom/getuserprofile?nasid=" + nasid + "&classification=manager"
          )
          .then(response => {
            this.managerUserId = response.data.data.id;
            this.managerName = response.data.data.name;
            this.managerNumber = response.data.data.mobile;
            this.managerEmail = response.data.data.email;
          });
      });
    },
    ShowTroubleShoot: function() {
      //console.log("show trouble shooting");
      this.showTroubleShooting = true;
    },
    HideTroubleShoot: function() {
      //console.log("hide trouble shooting");
      this.showTroubleShooting = false;
    },
    SearchSettings: function() {
      var nasid = this.selectedLocation.nasid;
      let that = this;
      AdminServicesAxios
        .get("v1/Settings/SearchSettings?nasid=" + nasid)
        .then(response => {
          that.settingId = response.data.data[0].settingId;
        });
      if(!this.selectedLocation.upiId) {
        WIOM_APIS.getPaymentModes(nasid).then(res=>{
          if(res.upiId) {
            that.selectedLocation.upiId = res.upiId;
            that.storeData[0].upiId = res.upiId
          }
          that.storeData[0].cash = false;
          if (res.cash && res.cash == "true")
            that.storeData[0].cash = true;
          that.$emit("get-locations", that.storeData);
        });
      } else {
        that.$emit("get-locations", that.storeData);
      }
      if(!this.skipped) {
        WIOM_APIS.getPlans(this.selectedLocation.nasid).then((res)=> {
          if(res.data.length == 0 && !that.skipped) {
            that.planNPayPage = 'plans';
            that.defaultPlans = helper.getDefaultPlans()
            that.planNPayOn = true;
          } else if(that.selectedLocation.subscription.name == 'WIOM PDO') {
            WIOM_APIS.searchSpreadSheet({
              sheet_name: 'gaurentee',
              key: 'mobile',
              value: that.owner.ownerNumber
            }).then(res => {
              if(!res.sheet_data.length) {
                that.planNPayPage = 'gaurenteeCampaign';
                that.planNPayOn = true;
              }
            })
          }
        });
      }
    }
  }
};
</script>
